export default {
      id: "play-usage",
      viewBox: "0 0 18 19",
      url: __webpack_public_path__ + "sprite-b22400405c828da77637c810bce88f05.svg#play",
      toString: function () {
        return this.url;
      }
    }